import { RefreshCw, X } from 'lucide-react'

import { usePWA } from '@/contexts/pwa-context'

/**
 * PWA 更新提示组件
 * 当有新版本可用时显示更新提示
 */
export function UpdatePrompt() {
  const { needRefresh, offlineReady, updateServiceWorker } = usePWA()

  // 如果没有更新且不是离线就绪状态，不显示
  if (!needRefresh && !offlineReady) {
    return null
  }

  const handleUpdate = async () => {
    await updateServiceWorker()
  }

  const handleClose = () => {
    // 用户选择稍后更新，不做任何操作
    // 下次刷新页面时会自动更新
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-lg shadow-lg border p-4 z-50">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
          <RefreshCw className="h-5 w-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900">
            {needRefresh ? '发现新版本' : '离线模式已就绪'}
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            {needRefresh
              ? '新版本已准备就绪，点击更新以获取最新功能'
              : '应用已缓存，可以在离线状态下使用'}
          </p>
        </div>
        {!needRefresh && (
          <button
            onClick={handleClose}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600"
            aria-label="关闭"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>
      {needRefresh && (
        <div className="flex gap-2 mt-4">
          <button
            onClick={handleClose}
            className="flex-1 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
          >
            稍后更新
          </button>
          <button
            onClick={() => void handleUpdate()}
            className="flex-1 px-4 py-2 text-sm text-white bg-green-500 hover:bg-green-600 rounded-md transition-colors flex items-center justify-center gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            立即更新
          </button>
        </div>
      )}
    </div>
  )
}
